import { connect } from "react-redux";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, Typography
} from "@mui/material";
import * as React from "react";
import { successToast } from "../../../helpers/Notification";
import { getSuccessMessage } from "../../../store/helpers/common_functions";
import { useHistory } from "react-router-dom";

function CreateMinutesDialog({ open, handleClose, meeting, setOpen, DeleteAction, PutAction, url, onSuccess, info, title, bodyText, maxWidth, body, buttonTitle, systemSettings }) {

    const mainBackground = systemSettings?.mainBackground;

    const [deleting, setDeleting] = React.useState(false);
    const [error, setError] = React.useState();
    let history = useHistory();


    return <Dialog open={open} fullWidth={true} maxWidth={maxWidth ?? 'xs'} onClose={handleClose}>
        {deleting ? (
            <div
                className={
                    "absolute h-full w-full top-0 left-0 flex z-50 justify-center items-center"
                }
                style={{ backgroundColor: info ? "rgba(83,220,85,0.2)" : "rgba(220,83,83,0.2)" }}
            >
                <div
                    className={"bg-white p-3 rounded shadow text-center"}
                    style={{ zIndex: 20000 }}
                >
                    <div>
                        <CircularProgress color={info ? 'success' : "error"} />
                    </div>
                    <span>
                        <Typography color={info ? 'success' : 'error'}>{info ? 'Submitting' : 'Deleting'} ....</Typography>
                    </span>
                </div>
            </div>
        ) : null}
        <DialogTitle>{"Create minutes"}</DialogTitle>
        <DialogContent>
            {error ? (
                <Alert
                    style={{ width: "100%" }}
                    className={"mb-3"}
                    severity={"error"}
                    onClose={() => setError(null)}
                >
                    {error}
                </Alert>
            ) : null}
            <div className={'flex items-center'}>
                <DialogContentText>{"Please create minutes"}</DialogContentText>
            </div>
        </DialogContent>
        <DialogActions>
            <Button color={'error'} onClick={handleClose}>Cancel</Button>
            <Button onClick={() => {
                history.push("/admin/create-minutes", {
                    selected: meeting?.id,
                    meeting: meeting,
                });
            }}
                variant={'contained'} sx={{
                    backgroundColor: mainBackground ? mainBackground : '#526680',
                }}>{'Create'}</Button>
        </DialogActions>
    </Dialog>
}

export default connect(null, mapDispatchToProps)(CreateMinutesDialog);